import React, { useState } from 'react'
import styled from 'styled-components'

import { Helmet } from 'react-helmet'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { CloudDownload as MuiCloudDownload } from '@material-ui/icons'

import {
  useQueryPaginator,
  PaginatedTable,
  AddressField,
  ValueField,
  LinkedField,
} from 'src/components/Table'
import { ExportDialog } from 'src/components/Dialog'

import { skuit } from 'src/services/skuit'

const Button = styled(MuiButton)(spacing)

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const CloudDownload = styled(MuiCloudDownload)(spacing)
const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export const FacilityListPage = () => {
  const [exportOpen, setExportOpen] = useState(false)

  const paginator = useQueryPaginator('facility-list', skuit.client.facilities.list, { params: { storing: true } })

  return (
    <>
      <Helmet title="Facilities" />

      <Grid justify="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Facilities
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} exact to="/">
              Dashboard
            </Link>
            <Typography>Facilities</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => setExportOpen(true)}>
            <CloudDownload mr={2} /> Export Facilities to CSV
          </Button>
        </Grid>
        <Grid item xs={12}>
          <PaginatedTable
            title="Facilities"
            fields={[
              { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
              { id: 'address', label: 'Address', renderer: AddressField },
            ]}
            paginator={paginator}
          />
        </Grid>
      </Grid>
      <ExportDialog
        name="Facilities"
        download={skuit.client.facilities.export}
        open={exportOpen}
        fields={[
          "address1",
          "address2",
          "city",
          "guid",
          "name",
          "postal_code",
          "state",
        ]}
        handleClose={() => setExportOpen(false)}
      />
    </>
  )
}
